import React, { useState, useEffect } from "react";
import { HeaderConfig } from "./config";
import CustomTable from "../../../../core/custom-table";
import ServiceBulletinsFilters from "./service-bulletin-filters";
import { HTTP_METHODS, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import AttachmentModal from "../../../../components/attachment-modal";
import { PAGE_LIMIT } from "../../../../utils";
const ServiceBulletins = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  const [downloadAttachment, setDownloadAttachment] = useState({
    isOpen: false,
    data: [],
  });
  const ClickHandler = (type, data) => {
    switch (type) {
      case "DOWNLOAD":
        setDownloadAttachment({
          isOpen: true,
          data: [...data.attachments],
        });
        break;

      default:
        break;
    }
  };
  const loadData = (filters) => {
    const payload = { ...filters, approvalStatus: "APPROVED" };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SERVICE_BULLETINS}/oem`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res.results.map((ele, index) => ({
            ...ele,
            sNo: index + 1,
          }));
          setData({ ...res, results: result });
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Literature</p>
        <p className="section-name">Service Bulletins</p>
      </div>
      <div className="si-hide-mobile">
        <CustomTable
          header={HeaderConfig}
          data={data.results || []}
          pageCount={data.totalPages}
          filters={filters}
          onClick={ClickHandler}
          onChange={(page) => {
            setFilters({
              ...filters,
              page,
            });
            loadData({
              ...filters,
              page,
            });
          }}
          filterCom={<ServiceBulletinsFilters loadData={loadData} />}
          isLoading={isLoading}
        />
      </div>
      {downloadAttachment?.isOpen && (
        <AttachmentModal
          attachments={downloadAttachment?.data}
          onClose={() => setDownloadAttachment({ isOpen: false, data: [] })}
          isOemDownload={true}
        />
      )}
    </div>
  );
};

export default ServiceBulletins;
